import seo from "./pages.json";
import blog from "./blog.json";

export const nyToday = () => new Intl.DateTimeFormat("en-CA", { timeZone: "America/New_York", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
export const allPosts = blog.posts;
const today = nyToday();
blog.posts = allPosts.filter((p) => p.publishDate <= today);

seo.pages["/blog"] = { ...blog.index, image: blog.posts[0].cover, ogImage: blog.posts[0].ogImage, priority: "0.7", schema: "webpage",
  sections: [], links: blog.posts.map((p) => ({ href: `/blog/${p.slug}`, label: p.title })) };
blog.posts.forEach((p) => {
  seo.pages[`/blog/${p.slug}`] = { title: p.title, description: p.description, h1: p.title, intro: p.lede, image: p.cover, ogImage: p.ogImage,
    ogType: "article", priority: "0.6", schema: "article", datePublished: p.publishDate, lastmod: p.publishDate, blocks: [...p.blocks, { type: "p", text: p.cta }], sections: [],
    links: [
      ...(blog.posts.some((b) => b.slug === p.related) ? [{ href: `/blog/${p.related}`, label: `Read next: ${blog.posts.find((b) => b.slug === p.related).title}` }] : []),
      ...(p.booking ? [{ href: p.booking, label: "Book your cabin" }] : []),
    ] };
});
if (!seo.nav.some((n) => n.href === "/blog")) seo.nav.splice(seo.nav.length - 1, 0, { label: "Blog", href: "/blog" });

export { seo, blog };

export const urlFor = (siteUrl, p) => `${siteUrl}${p}`;

export const buildSchema = (p, siteUrl) => {
  const page = seo.pages[p];
  if (page.schema === "article") {
    return {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      headline: page.title,
      description: page.description,
      image: [`${siteUrl}${page.ogImage}`],
      url: urlFor(siteUrl, p),
      mainEntityOfPage: urlFor(siteUrl, p),
      datePublished: page.datePublished,
      author: { "@type": "Organization", name: seo.siteName, url: siteUrl },
      publisher: { "@type": "Organization", name: seo.siteName, url: siteUrl, logo: { "@type": "ImageObject", url: `${siteUrl}${seo.defaultImage}` } },
    };
  }
  const org = { "@type": "Organization", name: seo.siteName, url: siteUrl, logo: `${siteUrl}${seo.defaultImage}`, telephone: "+1-470-632-8963" };
  if (page.schema === "event") {
    const e = page.event;
    return {
      "@context": "https://schema.org",
      "@type": "Event",
      name: e.name,
      description: page.description,
      startDate: e.startDate,
      endDate: e.endDate,
      eventStatus: "https://schema.org/EventScheduled",
      eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
      image: [`${siteUrl}${page.image}`],
      url: urlFor(siteUrl, p),
      location: { "@type": "Place", name: e.location, address: { "@type": "PostalAddress", addressLocality: e.locality, addressRegion: e.region, addressCountry: e.country } },
      offers: { "@type": "Offer", price: e.price, priceCurrency: "USD", availability: "https://schema.org/InStock", url: e.bookingUrl, validFrom: "2025-01-01" },
      organizer: org,
      performer: { "@type": "Person", name: "DJ DaVyne" },
    };
  }
  if (page.schema === "organization") return { "@context": "https://schema.org", ...org };
  return { "@context": "https://schema.org", "@type": "WebPage", name: page.title, description: page.description, url: urlFor(siteUrl, p), publisher: org };
};

